import React from 'react';
import PropTypes from 'prop-types';

import IconSadFace from './IconSadFace';
import PlayTime from './PlayTime';
import Players from './Players';

const BoardgameListItem = (props) => {
  const onReserveButtonClicked = (event) => {
    props.onReserveBoardgame && props.onReserveBoardgame(props.id);
  };

  const onGetBackButtonClicked = (event) => {
    props.onGetBackBoardgame && props.onGetBackBoardgame(props.id);
  };

  return (
    <div className="boardgame-list-item flex max-w-md w-full rounded flex-col overflow-hidden shadow-lg mb-10 bg-white md:mx-5 mx-0">
      <div className="w-full flex flex-row">
        <div className="block relative flex-grow-0 flex-shrink-0 h-24 w-24">
          <div
            className="h-full w-full flex-none bg-cover bg-top rounded-l rounded-r-none rounded-bl-none text-center overflow-hidden"
            style={{backgroundImage: `url('${props.image}')`}}  title={props.title}>
          </div>
          {
            (props.availableCopies === 0 || props.availableCopies === props.reservedCopies) &&
              <div className="absolute h-full w-full flex flex-col justify-center items-center inset-0">
                <div className="absolute h-full w-full bg-gray-800 opacity-75 "></div>
                <IconSadFace className="z-10 w-1/3" fill="#FFFFFF" />
              </div>
          }
        </div>
        <div className="boardgame-list-item__description bg-white p-4 flex flex-1 flex-col justify-between leading-normal">
          <div className="text-black font-black mb-1 truncate font-serif">{ props.title }</div>
          <div className="flex justify-start">
            <div className="pr-2">
              <PlayTime minPlayTime={props.minPlayTime} maxPlayTime={props.maxPlayTime} />
            </div>
            <div className="pl-2">
              <Players minPlayers={props.minPlayers} maxPlayers={props.maxPlayers} />
            </div>
          </div>
        </div>
      </div>
      { props.showActions &&
        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 border-gray-200 border-t bg-gray-100">
          <button className={`text-gray-700 flex-1 font-bold py-3 px-3 border-gray-200 border-r flex justify-center items-center ${ props.availableCopies === props.reservedCopies ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-75' }`}
                  type="button"
                  disabled={props.availableCopies === props.reservedCopies}
                  onClick={onReserveButtonClicked}>
            {
              props.availableCopies - (props.reservedCopies || 0) > 0
                ? <span className="text-xs text-center mr-2 text-white font-bold bg-gray-600 rounded-full w-5 h-5">{ props.availableCopies - (props.reservedCopies || 0) }</span>
                : null
            }
            <span>Presta</span>
          </button>
          <button className={`text-gray-700 flex-1 font-bold py-3 px-3 flex justify-center items-center ${ props.reservedCopies === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:opacity-75' }`}
                  type="button"
                  disabled={props.reservedCopies === 0}
                  onClick={onGetBackButtonClicked}>
            {
              (props.reservedCopies || 0) > 0
                ? <span className="text-xs text-center mr-2 text-white font-bold bg-gray-600 rounded-full w-5 h-5">{ props.reservedCopies }</span>
                : null
            }
            <span>Restuisci</span>
          </button>
        </div>
      }
    </div>
  );
};

BoardgameListItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.string,
  minPlayTime: PropTypes.number.isRequired,
  maxPlayTime: PropTypes.number,
  minPlayers: PropTypes.number.isRequired,
  maxPlayers: PropTypes.number,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  showActions: PropTypes.bool,
  availableCopies: PropTypes.number,
  reservedCopies: PropTypes.number,
  onReserveBoardgame: PropTypes.func,
  onGetBackBoardgame: PropTypes.func,
};

BoardgameListItem.defaultProps = {
  categories: [],
  showActions: false,
  availableCopies: 0,
  reservedCopies: 0,
  onReserveBoardgame: () => {},
  onGetBackBoardgame: () => {},
};

export default BoardgameListItem;